import { ISobCompetitor } from 'partner360/models/ISobCompetitor'

import { HP_COMPETITOR_ID, OTHER_COMPETITOR_ID } from '../constants'

import { calculateFields } from './calculateFields'
import { calculateOtherSob } from './calculateOtherSob'
import { getFieldsWithCurrencyAndValueType } from './getFieldsWithCurrencyAndValueType'
import { getSellThruField } from './getSellThruField'

interface IGetRecalculatedOther {
  competitors: ISobCompetitor[]
  field: string
}

export const getRecalculatedOther = ({ field, competitors }: IGetRecalculatedOther) => {
  const sellThruField = getSellThruField(field)
  const fieldsToChange = getFieldsWithCurrencyAndValueType(sellThruField)

  return competitors.map((comp) => {
    if (comp.CompetitorID === OTHER_COMPETITOR_ID) {
      const hpItem = competitors.find(
        (el) => el.EntryId === comp.EntryId && el.CompetitorID === HP_COMPETITOR_ID
      )
      const otherSob = calculateOtherSob({
        competitors,
        field,
        entryId: comp.EntryId,
      })
      const objWithCalckedFieldsForOther = calculateFields({
        fields: fieldsToChange,
        hpItem,
        field,
        value: otherSob,
      })

      return {
        ...comp,
        [field]: otherSob,
        ...objWithCalckedFieldsForOther,
      }
    }

    return comp
  }, [])
}
